export enum CellErrorType {
  NONE = 0,
  NIGHT = 1,
  DAY = 2,
  SLEEPER = 3
}
